/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Go_Further_Tile_SubtitleInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} service to discover" |
* | "other" | "{count} services to discover" |
*
* @param {Go_Further_Tile_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_tile_subtitle = /** @type {((inputs: Go_Further_Tile_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Tile_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} service to discover`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} services to discover`);
		return /** @type {LocalizedString} */ ("go_further_tile_subtitle");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} service à découvrir`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} services à découvrir`);
		return /** @type {LocalizedString} */ ("go_further_tile_subtitle");
	}
});